import { InputAdornment, TextField } from '@mui/material'
import { useFieldContext } from '@zealth/core/form/contexts'
import type { MoneyFormFieldProps } from '@zealth/core/formFields/types'
import { DollarSign } from 'lucide-react'
import { NumericFormat } from 'react-number-format'

const MoneyAdornment = () => (
  <InputAdornment
    position="start"
    sx={{
      color: 'text.primary',
      opacity: 0.2,
    }}
  >
    <DollarSign className="size-6" data-testid="MoneyAdornmentIcon" />
  </InputAdornment>
)

export const MoneyFormField = ({
  label,
  placeholder,
  optional,
}: MoneyFormFieldProps) => {
  const field = useFieldContext<number | null>()

  return (
    <NumericFormat
      customInput={TextField}
      fullWidth
      label={label}
      placeholder={placeholder}
      required={!optional}
      allowNegative={false}
      allowLeadingZeros={false}
      decimalScale={0}
      thousandSeparator=","
      value={field.state.value}
      error={field.state.meta.errors.length > 0}
      helperText={field.state.meta.errors[0]?.message ?? ' '}
      onBlur={field.handleBlur}
      onValueChange={values => field.handleChange(values.floatValue ?? null)}
      slotProps={{
        input: {
          startAdornment: <MoneyAdornment />,
        },
      }}
    />
  )
}
